export const AppConstants = Object.freeze({
    COLOR_LIST_URL: './assets/json/ral.json',
    INSIDE_PROPS_URL: './assets/json/inside-props.json',
    MODELS_URL: './assets/json/models.json',
    INSIDE_COLORS_URL: './assets/json/inside-colors.json',
    INT_IMAGES_URL: './assets/img/interior/',
    BIG_SHELVES_CODE: 'IX0B',
    SMALL_SHELVES_CODE: 'IX0A',
    GLASS_SHELVES_CODE: 'IX0E',
    WATCH_SHELVES_CODE: 'IX0C',
    USB_SHELVES_CODE: 'IX0D',
    SEPARATOR_SHELVE_CODE: 'IX0D_IX0J',

    BIG_SHELVES_CODE2: 'IX02B',
    SMALL_SHELVES_CODE2: 'IX02A',
    GLASS_SHELVES_CODE2: 'IX02E',
    WATCH_SHELVES_CODE2: 'IX02C',
    SEPARATOR_SHELVE_CODE2: 'IX02D_IX02J',
});
